"use client";

export const STYLE_CONFIG: Record<string, { label: string; color: string; bg: string; border: string }> = {
  WHALE: { label: "Whale", color: "text-blue-500", bg: "bg-blue-500/10", border: "border-blue-500/20" },
  MARKET_MAKER: { label: "Market Maker", color: "text-purple-500", bg: "bg-purple-500/10", border: "border-purple-500/20" },
  ACTIVE_TRADER: { label: "Active Trader", color: "text-orange-500", bg: "bg-orange-500/10", border: "border-orange-500/20" },
  BUY_AND_HOLD: { label: "Buy & Hold", color: "text-cyan-500", bg: "bg-cyan-500/10", border: "border-cyan-500/20" },
  DEGEN: { label: "Degen", color: "text-red-500", bg: "bg-red-500/10", border: "border-red-500/20" },
  HIGH_CONVICTION: { label: "High Conviction", color: "text-amber-500", bg: "bg-amber-500/10", border: "border-amber-500/20" },
  CONTRARIAN: { label: "Contrarian", color: "text-violet-500", bg: "bg-violet-500/10", border: "border-violet-500/20" },
  VALUE_HUNTER: { label: "Value Hunter", color: "text-emerald-500", bg: "bg-emerald-500/10", border: "border-emerald-500/20" },
  MIXED: { label: "Mixed", color: "text-gray-500", bg: "bg-gray-500/10", border: "border-gray-500/20" },
};

interface TradingStyleBadgeProps {
  style: string | null | undefined;
  size?: "sm" | "md";
}

export default function TradingStyleBadge({ style, size = "sm" }: TradingStyleBadgeProps) {
  if (!style) return null;

  const config = STYLE_CONFIG[style] || { label: style.replace(/_/g, ' ').split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' '), color: "text-gray-500", bg: "bg-white/[0.06]", border: "border-white/[0.08]" };

  const sizeClasses = size === "sm"
    ? "text-[10px] px-1.5 py-0.5"
    : "text-xs px-2 py-0.5";

  return (
    <span className={`${config.bg} ${config.color} ${config.border} border ${sizeClasses} rounded-[5px] font-bold whitespace-nowrap`}>
      {config.label}
    </span>
  );
}
